/* tslint:disable */
/* eslint-disable */
export enum ProcessStatus {
  Processing = 'PROCESSING',
  Uploaded = 'UPLOADED',
  Failed = 'FAILED',
  Processed = 'PROCESSED',
}
